import moment from 'moment';
import _ from 'lodash';

export const PERMISSIONS = {
  dashboards: {
    full: 'manageDashboards',
    view: 'manageDashboardsViewOnly',
    create: 'createDashboards',
    entityId: 'dashboardId',
    entityName: 'dashboards',
    emptyLabel: 'No dashboards found',
    reminder: 'These settings give access to all existing and future team dashboards',
    label: 'Team Dashboards',
  },
  streams: {
    full: 'manageStreams',
    view: 'manageStreamsViewOnly',
    create: 'createStreams',
    entityId: 'streamId',
    entityName: 'streams',
    emptyLabel: 'No value streams found',
    reminder: 'These settings give access to all existing and future value streams',
    label: 'Value Streams',
  },
  portfolios: {
    full: 'managePortfolios',
    view: 'managePortfoliosViewOnly',
    create: 'createPortfolios',
    entityId: 'portfolioId',
    entityName: 'portfolios',
    emptyLabel: 'No portfolios found',
    reminder: 'These settings give access to all existing and future portfolios',
    label: 'Portfolios',
  }
};

export function getPremiumStatus(user) {
  if (!user.config) {
    return 'inactive';
  }
  if (!!user.config.exportTrialEnd) {
    if (moment(user.config.exportTrialEnd).diff(moment()) < 0) {
      return 'expired';
    }
  }
  if (user.config.exportDeactivationDate && !user.config.exportEnabled) {
    return 'deactivated';
  }  
  return user.config.exportEnabled ? 'active' : 'inactive';
}

export function getStreamAccessRights(user, stream) { 
  const permissions = user && user.permissions;
  const fullAccess = permissions && permissions.manageStreams;
  const viewAccess = permissions && permissions.manageStreamsViewOnly;
  const granularAccess = permissions && permissions.streams &&  _.find(permissions.streams, s => s.streamId === stream._id);
  const access = fullAccess && { view: true, edit: true, delete: true } || viewAccess && { view: true, edit: false, delete: false } || granularAccess || {};
  return access;
}

export function getPortfolioAccessRights(user, portfolio) { 
  const permissions = user && user.permissions;
  const fullAccess = permissions && permissions.managePortfolios;
  const viewAccess = permissions && permissions.managePortfoliosViewOnly;
  const granularAccess = permissions && permissions.portfolios && _.find(permissions.portfolios, s => s.portfolioId === portfolio._id);
  const access = fullAccess && { view: true, edit: true, delete: true } || viewAccess && { view: true, edit: false, delete: false } || granularAccess || {};
  return access;
}

export default {
  PERMISSIONS,
  getPremiumStatus,
  getStreamAccessRights,
  getPortfolioAccessRights,
};
